import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import Button from 'components/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import { removePaymentProblem } from 'services/StudentPaymentProblemsService'
import { Tooltip } from '@mui/material'
import { toast } from 'react-hot-toast'

const DeletePaymentProblemModal = ({ problem, onSuccess }) => {
  const [open, setOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleOpen = e => {
    e?.stopPropagation?.()
    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  const handleDelete = async () => {
    if (!problem) return
    setIsDeleting(true)
    try {
      await removePaymentProblem(problem.id)
      toast.success('Usunięto wpis')
      onSuccess?.()
      handleClose()
    } catch (err) {
      toast.error('Wystąpił błąd')
      console.error(err)
    } finally {
      setIsDeleting(false)
    }
  }

  if (!problem) return null

  return (
    <>
      <Tooltip title='Usuń wpis'>
        <Trigger onClick={handleOpen}>
          <StyledIcon />
        </Trigger>
      </Tooltip>
      <Modal open={open} onClose={handleClose} title='Usuń wpis'>
        <Content>
          Czy na pewno chcesz usunąć ten wpis? Wpis nie zostanie przypisany do żadnego ucznia.
        </Content>
        <ButtonsWrapper>
          <Button color='secondary' onClick={handleClose}>
            Anuluj
          </Button>
          <Button color='primary' onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? 'Usuwanie...' : 'Usuń'}
          </Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default DeletePaymentProblemModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(DeleteIcon)`
  transition: all 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.error || '#d32f2f'};
  }
`

const Content = styled.div`
  padding: 20px 0;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.border || '#eee'};
`
